"use client";

import React from "react";
import EditSection, { TextEditor } from "../../sections/shared/EditSection";
import { SectionContentProps } from "../../types";

export default function AIFooterEdit({
  content,
  onContentChange,
}: SectionContentProps) {
  const updateContent = (key: string, value: any) => {
    onContentChange?.({ ...content, [key]: value });
  };

  return (
    <EditSection
      content={content}
      onContentChange={onContentChange || (() => {})}
      contentFields={
        <div className="space-y-4">
          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Footer Text</h4>
            <TextEditor
              label="Brand Name"
              value={content.companyName}
              onChange={(v) => updateContent("companyName", v)}
              placeholder="AI STARTUP"
            />
            <TextEditor
              label="Copyright Text"
              value={content.copyright}
              onChange={(v) => updateContent("copyright", v)}
              placeholder="© 2026 Instacks. All rights reserved."
            />
          </div>
        </div>
      }
    />
  );
}
